<template>
  <div class="topic-manage">
    <div class="topic-manage-header">
      <div>我的专题</div>
    </div>
    <list-frame class="questionnaire-list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="10">
      <template v-slot:listContent>
        <div class="paper-list-content">
          <el-table v-loading="loading" :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
            <el-table-column prop="name" label="专题名称" min-width="200"> </el-table-column>
            <el-table-column prop="articleCounts" label="文章数量" min-width="50"> </el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="100"> </el-table-column>
            <el-table-column label="操作" min-width="150">
              <template slot-scope="scope">
                <div class="option-button" @click="shareItem(scope.row)">分享</div>
                <div class="option-button" @click="editItem(scope.row)">编辑</div>
                <div class="option-button" @click="delItem(scope.row)">删除</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </list-frame>
    <share-dialog ref="shareDialog" :qrObj="qrObj" :title="'分享报纸'" :typeName="typeName"></share-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ListFrame from '@components/list/listFrame'
import ShareDialog from '@components/books/components/ShareDialog.vue'
import api from '@api/paperManager'
import compareVipRight from '@components/common/compareVipRight.js'
import moment from 'moment'
export default {
  name: 'myTopics',
  mixins: [compareVipRight],
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      paperList: [],
      baozhiName: '',
      queryName: '',
      fromDate: '',
      toDate: '',
      isInset: true, //是否显示分享书刊嵌入代码
      typeName: 'paper',
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0,
        title: ''
      },
      loading: false,
      searched: false //标识：文章名称发生变化，且尚未点击搜索按钮
    }
  },
  components: { ListFrame, ShareDialog },
  computed: {
    userName() {
      return localStorage.getItem('username')
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    createTopicAble() {
      return this.searched && this.tableData.length && this.queryName.trim().length
    },
    resetAble() {
      return this.queryName.trim().length > 0 || this.baozhiName.length > 0 || this.fromDate || this.toDate
    }
  },
  watch: {
    queryName() {
      this.searched = false
    }
  },

  methods: {
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0) {
        return 'text-align: center'
      }
    },
    getTopicList() {
      this.loading = true
      const param = {
        pageNo: this.currentPageNo,
        pageSize: 10,
        userName: this.userName
      }
      api.getTopicByPage(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          let data = res.data.data
          this.tableData = data.content.map((item) => {
            item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
            return item
          })
          this.totalCount = data.totalElements
        }
        this.loading = false
      })
    },
    reset() {
      if (this.resetAble) {
        this.queryName = ''
        this.baozhiName = ''
        this.fromDate = ''
        this.toDate = ''
        this.getTopicList()
      }
    },
    //翻页
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getTopicList()
    },
    shareItem(item) {
      this.$refs.shareDialog.dialogVisible = true
      let routeUrl = this.$router.resolve({ path: '/topicArticleList', query: { id: item.id } })
      this.qrObj.value = window.location.origin + routeUrl.href
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.title = item.name
    },
    editItem(item) {
      this.$emit('topicEdit', item)
    },
    delItem(row) {
      this.$alert('确定要删除 ' + row.name + ' 吗？', '提示', {
        confirmButtonText: '确定'
      }).then(() => {
        api.delTopic({ ids: row.id }).then((res) => {
          this.getTopicList()
        })
      })
    }
  },
  mounted() {
    this.getTopicList()
  }
}
</script>
<style lang="scss" scoped>
.topic-manage {
  .topic-manage-header {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    .btn-wrapper {
      display: flex;
      padding-right: 20px;
      .create-btn {
        width: 140px;
        height: 30px;
        font-weight: 500;
        color: #ffffff;
        line-height: 30px;
        background-color: #df5813;
        border-radius: 6px;
        text-align: center;
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }
  .paper-list-content {
    .el-input {
      flex: 1;
      width: 200px;
      input {
        height: 100%;
      }
      .el-input__inner {
        font-size: 14px;
        padding: 2px;
      }
    }
    .table-head {
      padding-bottom: 20px;
      .btns {
        margin-top: 20px;
      }
    }
    .head-button {
      margin-right: 10px;
      color: #f0f0f0;
      font-size: 18px;
      line-height: 36px;
      vertical-align: top;
      text-align: center;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      background-color: rgba(223, 88, 19, 1);
      border-radius: 8px;

      .input_icon {
        width: 22px;
        height: 22px;
        margin-left: 12px;
        display: block;
      }
      span {
        display: block;
        margin: 0 17px;
      }
      &.inactive {
        background-color: #999999;
        cursor: not-allowed;
      }
    }
  }
  .option-button {
    display: inline-block;
    cursor: pointer;
    color: #df5813;
    margin-right: 20px;
  }
}
</style>
